import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Breadcrumbs, Input } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { translate, isNullOrEmpty } from '../../../../utils/util';
import StockService from '../../../../services/StockService';
import ModalUploadPallets from './ModalUploadPallets';

const PalletLabelRegistration = (props) => {
    const update = props.location?.state?.update;
    const [openModal, setOpenModal] = useState(false)
    const [palletLabel, setPalletLabel] = useState(props.location?.state?.update && props.palletLabel ? props.palletLabel : {
        area: '',
        street: '',
        position: '',
        level: '',
        adress: ''
    });

    const subtitles = () => {
        return [{ icon: "mdi mdi-plus-box-outline", label: 'Cadastro' }];
    }

    const onChange = (event) => {
        onValueChange(event, palletLabel, setPalletLabel);
    };

    const redirect = () => {
        props.history.replace('./list');
    }

    const onConfirm = () => {
        if (validateInputsRequired("formPalletLabelRegistration")) {
            palletLabel.adress = onAdress();
            if (update) {
                props.update(palletLabel, () => {
                    redirect();
                });
            }
            else {
                props.add(palletLabel, () => {
                    redirect();
                });
            }
        }
    };

    const onAdress = () => {
        var label = "";

        label += !isNullOrEmpty(palletLabel.area) ? palletLabel.area : "";
        label += !isNullOrEmpty(palletLabel.street) ? `.${palletLabel.street}` : "";
        label += !isNullOrEmpty(palletLabel.position) ? `.${palletLabel.position}` : "";
        label += !isNullOrEmpty(palletLabel.level) ? `.${palletLabel.level}` : "";

        return label;
    }

    return (
        <div>
            <Breadcrumbs id="palletLabelRegistration" title={{ icon: "mdi mdi-clipboard-check-outline", label: 'Etiqueta Porta Pallet' }} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formPalletLabelRegistration" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        onChange={onChange}
                                        required
                                        label="Área"
                                        id="area"
                                        name="area"
                                        type="text"
                                        value={palletLabel.area || ''}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        onChange={onChange}
                                        required
                                        label="Rua"
                                        id="street"
                                        name="street"
                                        type="text"
                                        value={palletLabel.street || ''}
                                        numericonly="true"
                                        leadingzeros={2}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        onChange={onChange}
                                        required
                                        label="Posição"
                                        id="position"
                                        name="position"
                                        type="text"
                                        value={palletLabel.position || ''}
                                        numericonly="true"
                                        leadingzeros={3}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        onChange={onChange}
                                        label="Nível"
                                        id="level"
                                        name="level"
                                        type="text"
                                        value={palletLabel.level || ''}
                                        numericonly="true"
                                        leadingzeros={2}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        onChange={onChange}
                                        required
                                        label="Endereço"
                                        id="adress"
                                        name="adress"
                                        type="text"
                                        value={onAdress()}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="input-field no-padding  col s1">
                                <button
                                    className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                    type="button"
                                    onClick={() => setOpenModal(true)}>
                                    <i className="Small material-icons">cloud_upload</i>
                                </button>
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalUploadPallets
                open={openModal}
                id="ModalUploadPartnumbers"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        palletLabel: state.stockReducer.palletLabel
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        add: (palletLabel, callback) => {
            dispatch(StockService.AddPalletLabel(palletLabel, callback));
        },
        update: (palletLabel, callback) => {
            dispatch(StockService.UpdatePalletLabel(palletLabel, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PalletLabelRegistration)));
